import { createAction, props } from '@ngrx/store';

const GET_QUERY_STRINGS = '[QueryString] Get Query Strings';
const GET_QUERY_STRINGS_SUCCESS = '[QueryString] Get Query Strings Success';
const GET_QUERY_STRINGS_FAILURE = '[QueryString] Get Query Strings Failure';
const SET_QUERY_STRINGS = '[QueryString] Set Query Strings';
const CREATE_QUERY_STRING = '[QueryString] Create Query String';
const CREATE_QUERY_STRING_SUCCESS = '[QueryString] Create Query String Success';
const CREATE_QUERY_STRING_FAILURE = '[QueryString] Create Query String Failure';
const UPDATE_QUERY_STRING = '[QueryString] Update Query String';
const UPDATE_QUERY_STRING_SUCCESS = '[QueryString] Update Query String Success';
const UPDATE_QUERY_STRING_FAILURE = '[QueryString] Update Query String Failure';
const DELETE_QUERY_STRING = '[QueryString] Delete Query String';
const DELETE_QUERY_STRING_SUCCESS = '[QueryString] Delete Query String Success';
const DELETE_QUERY_STRING_FAILURE = '[QueryString] Delete Query String Failure';
const RESET_QUERY_STRING_ACTION_STATE = '[QueryString] Reset Action State';

// Unified getQueryStrings action that handles pagination, sorting, and search
const getQueryStrings = createAction(GET_QUERY_STRINGS, props<{ 
  apiConstants: any; 
  filter?: { 
    start?: number; 
    length?: number; 
    order?: { column: string; dir: 'asc' | 'desc' }[];
    search?: any;
  }; 
  reset?: boolean 
}>());

const getQueryStringsSuccess = createAction(GET_QUERY_STRINGS_SUCCESS, props<{ queryStrings: any; totalRecords: number; append?: boolean }>());

const getQueryStringsFailure = createAction(GET_QUERY_STRINGS_FAILURE, props<{ error: any }>());

const setQueryStrings = createAction(SET_QUERY_STRINGS, props<{ queryStrings: any; totalRecords: number }>());

const createQueryString = createAction(CREATE_QUERY_STRING, props<{ apiConstants: any; queryStringData: any}>());
const createQueryStringSuccess = createAction(CREATE_QUERY_STRING_SUCCESS, props<{ queryString: any }>());
const createQueryStringFailure = createAction(CREATE_QUERY_STRING_FAILURE, props<{ error: any }>());

const updateQueryString = createAction(UPDATE_QUERY_STRING, props<{ apiConstants: any; queryStringData: any}>());
const updateQueryStringSuccess = createAction(UPDATE_QUERY_STRING_SUCCESS, props<{ queryString: any }>());
const updateQueryStringFailure = createAction(UPDATE_QUERY_STRING_FAILURE, props<{ error: any }>());

const deleteQueryString = createAction(DELETE_QUERY_STRING, props<{ apiConstants: any; queryStringId: string }>());
const deleteQueryStringSuccess = createAction(DELETE_QUERY_STRING_SUCCESS, props<{ queryStringId: string }>());
const deleteQueryStringFailure = createAction(DELETE_QUERY_STRING_FAILURE, props<{ error: any }>());

const resetQueryStringActionState = createAction(RESET_QUERY_STRING_ACTION_STATE);

export {
  getQueryStrings,
  getQueryStringsFailure,
  getQueryStringsSuccess,
  setQueryStrings,
  createQueryString,
  createQueryStringSuccess,
  createQueryStringFailure,
  updateQueryString,
  updateQueryStringSuccess,
  updateQueryStringFailure,
  deleteQueryString,
  deleteQueryStringSuccess,
  deleteQueryStringFailure,
  resetQueryStringActionState
};
